export const productsSliderOptions = (instance, options, maxItems,spaceBetween) => {
    // const hasCartLayout = instance.classList.contains('has-cart-layout')

    let responsiveItemCounts = {
        1280: 5,
        1024: 4,
    }

    // if (hasCartLayout) {
    //     // nothing
    // } else {
    //     responsiveItemCounts = {...responsiveItemCounts, ...{
    //     }}
    // }

    let breakpoints = {}

    for (const resolution in responsiveItemCounts) {
        const count = Math.min(responsiveItemCounts[resolution], Number(maxItems));

        breakpoints[resolution] = {
            slidesPerView: count,
            slidesPerGroup: 1,
            spaceBetween: Number(spaceBetween) || 30,
            cssMode: false,
            pagination: {
                el: instance.paginationEl,
                dynamicBullets: false,
            }        
        }
    }

    return {
        loop: false,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: Number(spaceBetween) || 20,
        cssMode: true,
        breakpoints: breakpoints
    }
}